function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.679 6.32a1.174 1.174 0 00-1.569-.08c-.066.054-.014.006-1.027 1.019l2.629 2.63.945-.934c.457-.457.457-1.2 0-1.657l-.978-.978zM10.69 12.701l-1.546 3.315a.586.586 0 00.778.779l3.315-1.547c.131-.062-.266.31 4.641-4.536l-2.624-2.624c-4.865 4.865-4.501 4.48-4.563 4.613z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.224 15.968a1.755 1.755 0 01-.492.342l-3.314 1.546a1.755 1.755 0 01-1.986-.35 1.763 1.763 0 01-.35-1.986l1.546-3.314c.087-.187.205-.355.35-.5l4.983-4.983V1.758A1.76 1.76 0 0013.203 0H1.758A1.76 1.76 0 000 1.758v16.484C0 19.212.79 20 1.758 20h11.446a1.76 1.76 0 001.757-1.758V15.24l-.737.729zM3.125 3.789h8.75a.586.586 0 010 1.172h-8.75a.586.586 0 010-1.172zm0 3.125H10a.586.586 0 010 1.172H3.125a.586.586 0 010-1.172zm-.586 3.711c0-.324.263-.586.586-.586h5a.586.586 0 110 1.172h-5a.586.586 0 01-.586-.586z",
  fill: "#fff"
});

function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgNote;